import { UserCenterRoutes } from '@/constants/PageRoutes'
import { APP_CONFIG } from '@/project-config'
import type { RouteRecordRaw } from 'vue-router'

export const getKycRouter = (): RouteRecordRaw[] => {
  if (!APP_CONFIG.isKYC) return []
  return [
    {
      path: UserCenterRoutes.RealNameAuth,
      component: () => import('@/views/UserCenter/RealNameAuth'),
      meta: {
        title: '身份认证',
      },
    },
    {
      path: 'identity-verification',
      component: () => import('@/views/UserCenter/IdentityVerification'),
      meta: {
        title: '身份认证表单',
      },
    },
    {
      path: 'liveness-verification',
      component: () => import('@/views/UserCenter/LivenessVerificationNative'),
      meta: {
        title: '活体认证',
      },
    },
    {
      path: 'video-verification',
      component: () => import('@/views/UserCenter/VideoVerification'),
      meta: {
        title: '活体认证',
      },
    },
    {
      path: 'identity-review-pending',
      component: () => import('@/views/UserCenter/components/Kyc/IdentityReviewPending'),
      meta: {
        title: '身份审核中',
      },
    },
    {
      path: 'identity-verification-success',
      component: () => import('@/views/UserCenter/components/Kyc/IdentityVerificationSuccess'),
      meta: {
        title: '身份验证成功',
      },
    },
  ]
}
